/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useSupercaseList = makeQueryHook(operations.supercaseList)

export const useSupercaseCreate = makeMutationHook(operations.supercaseCreate)

export const useSupercaseMembersTemplateCsv = makeQueryHook(
  operations.supercaseMembersTemplateCsv,
)

export const useSupercaseGet = makeQueryHook(operations.supercaseGet)

export const useSupercaseUpdate = makeMutationHook(operations.supercaseUpdate)

export const usePopulationList = makeQueryHook(operations.populationList)

export const useCommittedMembersListCsv = makeQueryHook(
  operations.committedMembersListCsv,
)

export const useDraftPopulationGet = makeQueryHook(
  operations.draftPopulationGet,
)

export const useDraftPopulationMembersList = makeQueryHook(
  operations.draftPopulationMembersList,
)

export const useDraftPopulationMembersSet = makeMutationHook(
  operations.draftPopulationMembersSet,
)

export const useDraftPopulationMembersAdd = makeMutationHook(
  operations.draftPopulationMembersAdd,
)

export const useDraftPopulationMembersListCsv = makeQueryHook(
  operations.draftPopulationMembersListCsv,
)

export const useDraftPopulationMembersSetCsv = makeMutationHook(
  operations.draftPopulationMembersSetCsv,
)

export const useDraftPopulationMembersAddCsv = makeMutationHook(
  operations.draftPopulationMembersAddCsv,
)

export const useDraftPopulationCommit = makeMutationHook(
  operations.draftPopulationCommit,
)

export const usePopulationGet = makeQueryHook(operations.populationGet)

export const usePopulationUpdate = makeMutationHook(operations.populationUpdate)

export const usePopulationMembersList = makeQueryHook(
  operations.populationMembersList,
)

export const usePopulationMembersListCsv = makeQueryHook(
  operations.populationMembersListCsv,
)

export const useInternalSupercaseList = makeQueryHook(
  operations.internalSupercaseList,
)

export const useInternalSupercaseCreate = makeMutationHook(
  operations.internalSupercaseCreate,
)

export const usePrivateNoteList = makeQueryHook(operations.privateNoteList)

export const usePrivateNoteCreate = makeMutationHook(
  operations.privateNoteCreate,
)

export const usePrivateNoteGet = makeQueryHook(operations.privateNoteGet)

export const usePrivateNoteUpdate = makeMutationHook(
  operations.privateNoteUpdate,
)

export const useGlobalNoteList = makeQueryHook(operations.globalNoteList)

export const useGlobalNoteCreate = makeMutationHook(operations.globalNoteCreate)

export const useGlobalNoteGet = makeQueryHook(operations.globalNoteGet)

export const useGlobalNoteUpdate = makeMutationHook(operations.globalNoteUpdate)

export const useGetSupercaseDocuments = makeQueryHook(
  operations.getSupercaseDocuments,
)

export const useSetSupercaseDocuments = makeMutationHook(
  operations.setSupercaseDocuments,
)

export const useAddSupercaseDocuments = makeMutationHook(
  operations.addSupercaseDocuments,
)

export const useSupercaseBulkUpdate = makeMutationHook(
  operations.supercaseBulkUpdate,
)

export const useSupercaseBulkSendMessage = makeMutationHook(
  operations.supercaseBulkSendMessage,
)

export const usePopulationBulkSendMessage = makeMutationHook(
  operations.populationBulkSendMessage,
)

export const useSupercaseBulkCreateDni = makeMutationHook(
  operations.supercaseBulkCreateDni,
)

export const useSupercaseBulkDeleteDni = makeMutationHook(
  operations.supercaseBulkDeleteDni,
)

export const useSupercaseBulkOperationList = makeQueryHook(
  operations.supercaseBulkOperationList,
)

export const useSupercaseBulkOperationSearch = makeQueryHook(
  operations.supercaseBulkOperationSearch,
)

export const useSupercaseBulkOperationGet = makeQueryHook(
  operations.supercaseBulkOperationGet,
)

export const useSupercaseBulkOperationUpdate = makeMutationHook(
  operations.supercaseBulkOperationUpdate,
)

export const useGetBulkOperationTargetPopulations = makeQueryHook(
  operations.getBulkOperationTargetPopulations,
)

export const useGetMemberBulkOperationResultsByOperation = makeQueryHook(
  operations.getMemberBulkOperationResultsByOperation,
)

export const useUpdateMemberBulkOperationResult = makeMutationHook(
  operations.updateMemberBulkOperationResult,
)

export const useInternalSupercaseBulkOperationGet = makeQueryHook(
  operations.internalSupercaseBulkOperationGet,
)

export const useInternalSupercaseBulkOperationList = makeQueryHook(
  operations.internalSupercaseBulkOperationList,
)

export const useSupercaseCaseCount = makeQueryHook(
  operations.supercaseCaseCount,
)
